import { render } from "./CreateLabelsModal.vue?vue&type=template&id=9d3befee&scoped=true"
import script from "./CreateLabelsModal.vue?vue&type=script&lang=js"
export * from "./CreateLabelsModal.vue?vue&type=script&lang=js"

import "./CreateLabelsModal.vue?vue&type=style&index=0&id=9d3befee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d3befee"]])

export default __exports__